"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationPartner',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        partnerType: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadList();
  },
  methods: {
    typeText: function typeText(value) {
      return {
        real_estate: '房产',
        property: '物业',
        supervision: '监理',
        supplier: '供应商',
        designer: '设计师',
        foreman: '工长'
      }[value] || value;
    },
    statusText: function statusText(value) {
      return {
        invited: '已邀请',
        pending: '待确认',
        negotiating: '洽谈中',
        active: '合作中',
        rejected_by_me: '我方拒绝',
        rejected_by_partner: '对方拒绝',
        blacklisted: '已拉黑',
        cancelled: '已取消'
      }[value] || value;
    },
    actionText: function actionText(value) {
      return {
        confirm: '确认',
        negotiate: '洽谈',
        activate: '激活',
        reject: '拒绝',
        partner_reject: '对方拒绝',
        blacklist: '拉黑',
        cancel: '取消'
      }[value] || value;
    },
    loadList: function loadList() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationPartnerListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadList();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('合作方名称', '邀请供应商').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationPartnerSaveApi)({
          partnerType: 'supplier',
          partnerName: value || 'E2E合作供应商',
          contactName: '渠道经理',
          policyText: '后台邀请合作'
        }).then(function () {
          _this2.$message.success('已邀请');
          _this2.loadList();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationPartnerActionApi)(row.partner.id, {
          action: action
        }).then(function () {
          _this3.$message.success('合作关系已更新');
          _this3.loadList();
        });
      }).catch(function () {});
    }
  }
};